import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { selectWorldById, setEditId } from "../../../store/mods_factory/worldsSlice";
import { destroyWorld, fetchWorld } from "../../../actions/mods_factory/worldsActions";
import { fetchCategories } from "../../../actions/mods_factory/categoriesActions";
import modsfactoryUrls from "../../../configs/mods_factory/modsfactoryUrls";

import {
  LikeOutlined,
  MessageOutlined,
  StarOutlined,
  DownloadOutlined
} from "@ant-design/icons";
import { message } from "antd";
import Tabs from "../../../componets/Tabs";
import PageLayout from "../_partials/PageLayout";
import IconText from "../../../componets/IconText";
import StatsIcons from "../../../componets/StatsIcons";
import Edit from "./Edit";
import SummaryShow from "../../../componets/SummaryShow";
import SidebarShow from "./_partials/_SidebarShow";
import EditCategory from "../categories/Edit";
import ReorderCategories from "../categories/Reorder";
import NewCategory from "../categories/New";
import Details from "./_partials/_Details";
import Comments from "./_partials/_Comments";
import EditComment from "../Comments/Edit";
import { ButtonDestroy, ButtonEdit } from "../../../componets/Buttons";

const TARGET_ID = 2;

const Show: React.FC = () => {
  const { id }    = useParams();
  const navigate  = useNavigate();
  const dispatch  = useAppDispatch();
  const world      = useAppSelector(state => id ? selectWorldById(state, id) : undefined);

  useEffect(() => {
    if (id) {
      dispatch(fetchCategories({ target_id: TARGET_ID }));
      dispatch(fetchWorld(id));
    }
  }, [id, dispatch]);

  function onClickEdit() {
    if (world) {
      dispatch(setEditId(world.id));
    }
  }

  function onClickDestroy() {
    if (world) {
      handleDestroy(world.id).catch(console.error);
    }
  }

  async function handleDestroy (id: any) {
    const resultAction = await dispatch(destroyWorld(id));

    if (destroyWorld.fulfilled.match(resultAction)) {
      message.success(`ItemID ${id} was successful deleted`);
      setTimeout(() => navigate(modsfactoryUrls.worldsPath()), 1000);
    }

    if (destroyWorld.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  return (
    <PageLayout className='v-worlds-show'>
      <div className='v-container-fluid'>
        <div className='o-header'>
          {
            world &&
              <SummaryShow
                title={world.title}
                image={world.thumbnail_url}
                createdAt={world.created_at}
                updatedAt={world.updated_at}
                className='v-mb-15'
                actions={[
                  <ButtonEdit key='button-edit' onClick={onClickEdit} />,
                  <ButtonDestroy key='button-destroy' onClick={onClickDestroy} />
                ]}
              />
          }

          <StatsIcons
            icons={[
              <IconText tooltip='popular' icon={StarOutlined} text={world?.popular_count} />,
              <IconText tooltip='likes' icon={LikeOutlined} text={world?.likes_count} />,
              <IconText tooltip='downloads' icon={DownloadOutlined} text={world?.downloads_count} />,
              <IconText tooltip='comments' icon={MessageOutlined} text={world?.comments_count} />
            ]}
          />
        </div>

        <Tabs
          paramsKey='tab'
          items={[
            { label: 'Details', key: 'details', children: <Details world={world} /> },
            { label: 'Comments', key: 'comment', children: <Comments worldId={world?.id} /> }
          ]}
        />
      </div>

      <SidebarShow world={world} />

      <Edit />

      <NewCategory />
      <EditCategory />
      <ReorderCategories />

      <EditComment />
    </PageLayout>
  )
}

export default Show;
